import React, {useContext, Suspense} from 'react';
import { createRoot } from "react-dom/client";
import './assets/css/App.css';
import {HashRouter, Route, Switch, Redirect} from 'react-router-dom';
import {Center, ChakraProvider, Spinner} from '@chakra-ui/react';
import theme from './theme/theme';
import axios from "axios";
import {Context} from "./contexts/AuthContext";

import {AuthProvider} from './contexts/AuthContext';

// Seta timezone do Moment
import 'moment/locale/pt-br';

import {DrawerProvider} from "./contexts/SidebarContext";
import {ShowValuesProvider} from "./contexts/ValuesViewContext";
import { DownloadStatusProvider } from 'contexts/hooks/DownloadStatusContextProps';
import DelayedFallback from "./components/custom/DelayedFallback";
import {getBaseURL} from "./helpers/utils";

axios.defaults.baseURL = getBaseURL();

function CustomRoute({...rest}) {
    const {loading, authenticated} = useContext(Context);

    if (loading) {
        return <h1>Loading...</h1>;
    }

    if (!authenticated) {
        return <Redirect to="/auth/login"/>
    }

    return <Route {...rest} />;
}

const AuthLayout = React.lazy(() => import("./layouts/auth"));
const AdminLayout = React.lazy(() => import("./layouts/admin"));
const RTLLayout = React.lazy(() => import("./layouts/rtl"));

const container = document.getElementById("root");
const root = createRoot(container!);

const isOAuthPopupCallback = /^\/oauth2\/[^/]+\/callback/.test(
  window.location.pathname,
);

if (isOAuthPopupCallback) {
  root.render(
    <ChakraProvider theme={theme}>
      <Center h="100vh">
        <Spinner size="xl" thickness="4px" speed="0.65s" color="blue.500" />
      </Center>
    </ChakraProvider>,
  );

  setTimeout(() => {
    try {
      window.close();
    } catch {
    }
  }, 1000);
} else {
  root.render(
    <ChakraProvider theme={theme}>
      <React.StrictMode>
        <ShowValuesProvider>
          <DrawerProvider>
            <DownloadStatusProvider>
              <HashRouter>
                <AuthProvider>
                  <Suspense fallback={<DelayedFallback delay={300} />}>
                    <Switch>
                      <Route path={`/auth`} component={AuthLayout} />
                      <CustomRoute path={`/`} component={AdminLayout} />
                      <Route path={`/rtl`} component={RTLLayout} />
                      <Route path="*">
                        <Redirect to="/auth/login" />
                      </Route>
                    </Switch>
                  </Suspense>
                </AuthProvider>
              </HashRouter>
            </DownloadStatusProvider>
          </DrawerProvider>
        </ShowValuesProvider>
      </React.StrictMode>
    </ChakraProvider>,
  );
}
